import {
  Container,
  createMuiTheme,
  makeStyles,
  ThemeProvider,
  Grid,
  Hidden,
  Snackbar,
  Box,
  CircularProgress,
  Paper,
  Typography,
} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Alert } from "@material-ui/lab";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Advanced from "./Advanced";
import "./App.css";
import FiboList from "./FiboList";
import Header from "./Header";
import { useAdvanced } from "./hooks";
import Metadata from "./Metadata";
import Preview from "./Preview";
import { RootState } from "./store";
import { fetchIcons } from "./store/icons";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ccb25d",
    },
    secondary: {
      main: "#f44336",
    },
    /*type: "dark",
    background: {
      default: "#181818",
      paper: "#242424",
    },*/
    background: {
      //default: "#f0f0f0",
      //paper: "#242424",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

function App() {
  const classes = useStyles();

  // Load icons
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchIcons());
  }, [dispatch]);

  const exporting = useSelector(
    (state: RootState) => state.transient.exporting
  );

  const { advanced, veryAdvanced } = useAdvanced();

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Hidden smUp>
          <Alert severity="warning">
            This tool was not designed to work on your screen size (yet). You
            may experience some UI issues.
          </Alert>
        </Hidden>
        <Container className={classes.container} maxWidth="md">
          <Metadata />
          {advanced && <Advanced readOnly={!veryAdvanced} />}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Preview />
            </Grid>
            <Grid item xs={12} md={6}>
              <FiboList />
            </Grid>
          </Grid>
        </Container>
        <Snackbar
          open={exporting}
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        >
          <Paper>
            <Box px={2} py={1} display="flex" alignItems="center">
              <CircularProgress size={20} />
              <Box ml={2}>
                <Typography variant="body1">Loading...</Typography>
              </Box>
            </Box>
          </Paper>
        </Snackbar>
        <footer></footer>
      </ThemeProvider>
    </>
  );
}

export default App;
